import React from 'react';
import SidebarItem from './SidebarItem';

interface SideMenuProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const SideMenu: React.FC<SideMenuProps> = ({ activeTab, setActiveTab }) => (
  <div style={{
    width: 240,
    background: '#fff',
    color: '#23272f',
    borderRight: '1px solid #f1f1f4',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: 16,
    padding: 0,
    boxShadow: 'none',
  }}>
    <div style={{ width: '100%', padding: 0, margin: 0 }}>
      <div style={{ color: '#6c6f7f', fontWeight: 700, fontSize: 14, padding: '32px 0 8px 24px', letterSpacing: 0.2 }}>Instagram</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <div
          role="button"
          tabIndex={0}
          aria-pressed={activeTab === 'social'}
          onClick={() => setActiveTab('social')}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') setActiveTab('social');
          }}
          style={{ cursor: 'pointer', outline: 'none' }}
        >
          <SidebarItem
            icon="bi bi-people"
            label="Social listening"
            active={activeTab === 'social'}
          />
        </div>
        {/* <div
          role="button"
          tabIndex={0}
          aria-pressed={activeTab === 'posting'}
          onClick={() => setActiveTab('posting')}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') setActiveTab('posting');
          }}
          style={{ cursor: 'pointer', outline: 'none' }}
        >
          <SidebarItem
            icon="bi bi-plus-square"
            label="Create post"
            active={activeTab === 'posting'}
          />
        </div> */}
      </div>
    </div>
  </div>
);

export default SideMenu;
